import React, { useState } from "react";
import Table from "../../Common/Table";
import Pagination from "../../Common/Pagination";
import useAddStock from "./useAddStock";
import useStockForm from "./AddStockForm";
import { Link } from "react-router-dom";

const AddStocks = () => {
  const {
    columns,
    currentRows,
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
  } = useAddStock();
  console.log(currentRows);
  return (
    <div className="p-4 flex flex-col">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Stock</h1>
        <Link to="/mainDashboard/dashboardCt/addStockForm">
          <button className="bg-blueButton text-white text-sm py-[6px] px-4 md:py-2 rounded-md ">
            Add Stock
          </button>
        </Link>
      </div>

      <div className="my-2 mb-6  text-green  overflow-auto horizontalscroll">
        <Table className="bg-green50" columns={columns} data={currentRows} />
      </div>
      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default AddStocks;
